import { render, staticRenderFns } from "./PinBloqueado.vue?vue&type=template&id=ddf05aa0"
import script from "./PinBloqueado.vue?vue&type=script&lang=js"
export * from "./PinBloqueado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports